import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=e6898c56&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6898c56"]])

export default __exports__